import DiscussionIntegration from 'pages/integrations/containers/DiscussionContainer/discussionIndex';
import LtiConfiguration from 'pages/integrations/containers/LtiIntegrationContainer/ltiConfigurationIndex';
import BadgesContainer from 'pages/integrations/containers/BadgesContainer/badgesIndex';
import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const Integrations = () => {
  return (
    <div className="block form-container">
      <h2 className="mb-4">Integrations</h2>
      <div className="tabs" id="accountSettings">
        <Tabs defaultActiveKey="discussion" id="integration" className="mb-4">
          <Tab eventKey="discussion" title="Discussion Forum">
            <DiscussionIntegration />
          </Tab>
          <Tab eventKey="lti_integration" title="LTI Integration">
            <LtiConfiguration />
          </Tab>
          <Tab eventKey="badges" title="Badges">
            <BadgesContainer />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Integrations;
